import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { debugToConsole } from '../../dev/debug-operator';

import { LoginService } from '../../../core/auth';
import { Settings, SettingsService } from '../../../settings';

import { Direction } from './sticky-header.directive';

@Component({
  selector: 'lud-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
  useIdentityServer: boolean;
  bootstrapBaseUri: string;
  showHeader: boolean = true;
  isCollapsed: boolean = false;

  //Note: directionChanged and directionHandler$ are two way of consuming directive stickyHeader, directionHandler$ override directionChanged
  directionChanged(event) {
    this.showHeader = event === Direction.Up || event === Direction.Top;
  }
  directionHandler$ = (direction$: Observable<Direction>) =>
    direction$.pipe(
      //debugToConsole("direction$:"),
      tap((event) => {
        this.showHeader = event === Direction.Up || event === Direction.Top;
       }),
    )

  constructor(
    private loginService: LoginService,
    private settingsService: SettingsService
  ) {
    let settings = settingsService.get();
    this.bootstrapBaseUri = settings.bootstrapBaseUri;
    this.useIdentityServer = settings.useIdentityServer;
  }

  ngOnInit() {
  }

  private login() {
    this.loginService.login();
  }

  private logout() {
    this.loginService.logout();
  }

  get isLoggedIn() {
    return this.loginService.isLoggedIn;
  }
}
